import React from 'react';
import { Button, Layout } from 'antd';
import 'components/IconLibrary';
import { Redirect } from 'react-router-dom';
import useAuth from 'core/hooks/useAuth';
import { MenuFoldOutlined } from '@ant-design/icons';
import { ROLE_ADMIN } from 'constants/types';
import { Routes } from 'components/routes';
import SettingsMenu from './SettingsMenu';

const { Content, Sider } = Layout;

const Settings = (props) => {
  const { match, routes, roles, basePath } = props;
  const { hasRole, ...rest } = useAuth();
  const [collapsed, setCollapsed] = React.useState(true);

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  const baseRoute = '/app/settings';

  const index = window.location.href.indexOf(baseRoute);

  const isBaseRoute = !!window.location.href.substring(
    index + baseRoute.length,
    window.location.href.length
  );

  const defaultRoute = routes.find(
    (c) => c.roles === undefined || hasRole(...c.roles, ROLE_ADMIN)
  );

  console.log(rest);

  return (
    <Layout>
      {!isBaseRoute && <Redirect to={baseRoute + defaultRoute?.path} />}
      <Layout>
        <Sider
          width={280}
          theme="light"
          defaultCollapsed={collapsed}
          collapsed={collapsed}
        >
          <Button
            className="gx-w-100 gx-mb-2 ant-btn-bg-white"
            onClick={toggleCollapsed}
            type="primary"
            icon={
              <MenuFoldOutlined
                className="gx-fs-lg"
                rotate={collapsed ? 180 : 0}
              />
            }
          />

          <SettingsMenu routes={routes} match={match} collapsed={collapsed} />
        </Sider>
        <Layout>
          <Content className="gx-pl-2">
            <Routes
              match={match}
              routes={routes}
              roles={roles}
              basePath={basePath}
              isContainer
            />
          </Content>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default Settings;
